<div class="loader-wrapper" *ngIf="mode == 'default'">
  <div class="loader color-orange">
    <i class="fas fa-spinner fa-spin"></i> loading...
  </div>
</div>

    <!-- Preloader -->
    <div class="preeloader" *ngIf="mode == 'preload'">
      <div class="preloader-spinner"></div>
    </div>
    <!--/ End Preloader -->
